import { TCardElevation, TCardProps } from './Card.type';

export const CARD_ELEVATIONS: TCardElevation[] = [ 'elevation-0', 'elevation-1', 'elevation-2', 'elevation-3', 'elevation-4', 'elevation-5' ];
export const CARD_ELEVATION: { [key in TCardElevation]: key } = {
	none: 'none',
	['elevation-0']: 'elevation-0',
	['elevation-1']: 'elevation-1',
	['elevation-2']: 'elevation-2',
	['elevation-3']: 'elevation-3',
	['elevation-4']: 'elevation-4',
	['elevation-5']: 'elevation-5',
}

export const CARD_DEFAULT_PROPS: TCardProps = {
	elevation: CARD_ELEVATION.none
}
